import { Routes } from "@angular/router";
import { RoutingGuardService } from "../angular-common/routing-guard.service";
import { AboutComponent } from "./public-area/about/about.component";
import { LoginComponent } from "./security/login/login.component";
import { SetOrResetPasswordComponent } from "./security/set-or-reset-password/set-or-reset-password/set-or-reset-password.component";
import { SignUpComponent } from "./security/sign-up/sign-up.component";

export const basePublicRoutes: Routes = [
    { path: 'about', component: AboutComponent, canActivate: [RoutingGuardService] },
    { path: 'login', component: LoginComponent, canActivate: [RoutingGuardService] },
    { path: 'signup', redirectTo: 'sign-up', pathMatch: 'full' },
    { path: 'sign-up', component: SignUpComponent, canActivate: [RoutingGuardService] },
    { path: 'setpassword', redirectTo: 'set-password', pathMatch: 'full' },
    { path: 'set-password', component: SetOrResetPasswordComponent, canActivate: [RoutingGuardService] },
    { path: 'resetpassword', redirectTo: 'reset-password', pathMatch: 'full' },
    { path: 'reset-password', component: SetOrResetPasswordComponent, canActivate: [RoutingGuardService] }
];